export class ApplicationDto {
    orders: Order[] = [];
    makeToOrders: MakeToOrderDto = new MakeToOrderDto();
    returnOrders: ReturnOrder[] = [];
    returnMtoOrders: ReturnMto = new ReturnMto();
}

export class Order {
    confirmed: number = 0;
    declined: number = 0;
    dispatched: number = 0;
    inProcess: number = 0;
    inventoryCode: number = 0;
    inventoryName: string;
    received: number = 0;
    totalOrders: number = 0;
    unResolved: number = 0;
}

export class MakeToOrderDto {
    confirmed: number = 0;
    declined: number = 0;
    dispatched: number = 0;
    inProcess: number = 0;
    received: number = 0;
    totalOrders: number = 0;
    unResolved: number = 0;
}

export class ReturnOrder {
    inventory: number = 0;
    inventoryName: string;
    orders: number = 0;
    received: number = 0;
}

export class ReturnMto {
    orders: number = 0;
    received: number = 0;
}
